// Bewegliche & feste Feiertage inkl. 1-Tag-Puffer (Start -1 Tag, Ende +1 Tag).

// Osteralgorithmus nach Gauss/Butcher – gibt (year, month 1-12, day) zurück.
function easterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

// 4. Donnerstag im November (Thanksgiving) + 1 Tag = Black Friday.
function blackFriday(year) {
  const nov1 = new Date(year, 10, 1);
  const firstThuOffset = (4 - nov1.getDay() + 7) % 7; // 4 = Thu
  const thanksgiving = 1 + firstThuOffset + 21; // 4. Donnerstag
  return new Date(year, 10, thanksgiving + 1);
}

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

// Liefert für ein Jahr alle Feiertags-Zeiträume (inkl. Puffer, Start-Ende inklusive).
export function getHolidayRanges(year) {
  const easter = easterSunday(year);
  const goodFri = new Date(easter); goodFri.setDate(easter.getDate() - 2);
  const weihnachten = new Date(year, 11, 25);
  const silvester = new Date(year, 11, 31);
  const tde = new Date(year, 9, 3);
  const bf = blackFriday(year);
  const weltfrauen = new Date(year, 2, 8);
  const valentin = new Date(year, 1, 14);

  const range = (start, end) => {
    const s = new Date(start); s.setDate(s.getDate() - 1);
    const e = new Date(end); e.setDate(e.getDate() + 1);
    return { start: s, end: e };
  };

  return {
    weihnachten: range(new Date(year, 11, 24), new Date(year, 11, 26)),
    karfreitag: range(goodFri, goodFri),
    ostern: range(easter, new Date(easter.getFullYear(), easter.getMonth(), easter.getDate() + 1)),
    silvester: range(silvester, silvester),
    tag_der_deutschen_einheit: range(tde, tde),
    black_friday: range(bf, bf),
    weltfrauentag: range(weltfrauen, weltfrauen),
    valentinstag: range(valentin, valentin),
  };
}

export const HOLIDAY_LABELS = {
  weihnachten: "Weihnachten",
  karfreitag: "Karfreitag",
  ostern: "Ostern",
  silvester: "Silvester",
  tag_der_deutschen_einheit: "Tag der Deutschen Einheit",
  black_friday: "Black Friday",
  weltfrauentag: "Weltfrauentag",
  valentinstag: "Valentinstag",
};

export const HOLIDAY_ORDER = [
  "weihnachten", "karfreitag", "ostern", "silvester",
  "tag_der_deutschen_einheit", "black_friday", "weltfrauentag", "valentinstag",
];

function inRange(now, r) {
  return now >= r.start && now <= r.end;
}

// Ermittelt den aktiven Feiertag basierend auf toggles + aktuellem Datum.
export function getActiveHoliday(toggles, now = new Date()) {
  if (!toggles) return null;
  const ranges = getHolidayRanges(now.getFullYear());
  // Priorität: Karfreitag > Weihnachten > Ostern > Silvester > TDE > Black Friday > Weltfrauentag > Valentinstag
  for (const key of ["karfreitag", "weihnachten", "ostern", "silvester", "tag_der_deutschen_einheit", "black_friday", "weltfrauentag", "valentinstag"]) {
    if (toggles[key] && inRange(now, ranges[key])) return key;
  }
  return null;
}

export function nextOccurrenceLabel(key, now = new Date()) {
  const y = now.getFullYear();
  const r = getHolidayRanges(y)[key];
  const target = r.end < now ? getHolidayRanges(y + 1)[key] : r;
  return `${ymd(target.start)} – ${ymd(target.end)}`;
}
